import { render, staticRenderFns } from "./AppDistrictsNav.vue?vue&type=template&id=180cfd0c&"
import script from "./AppDistrictsNav.vue?vue&type=script&lang=js&"
export * from "./AppDistrictsNav.vue?vue&type=script&lang=js&"
import style0 from "./AppDistrictsNav.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports